import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { GuestExitSurveyService } from '../guest-exit-survey.service';
import { GuestExitSurvey } from '../guest-exit-survey';
import { GuestExitSurveyComponent } from '../guest-exit-surveyest/guest-exit-survey.component';
import { ReservationService } from '@app/_components/reservation';

@Component({
    selector: 'app-guest-exit-survey-list',
    templateUrl: './guest-exit-survey-list.component.html',
    styleUrls: ['./guest-exit-survey-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class GuestExitSurveyListComponent implements OnInit {
	// Query param filters (applied from URL, e.g. ?overallExperienceRank=1&receiveDate=2026-04-07)
	initialOverallRankFilter: string = null;
	initialReceiveDateFilter: string = null;

	constructor(
		private guestExitSurveyService: GuestExitSurveyService,
		private constantService: ConstantService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private reservationService: ReservationService,
		private route: ActivatedRoute
	) {
		this.statuses = guestExitSurveyService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	guestExitSurveys: any;
	guestExitSurvey: GuestExitSurvey;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	rankFilterOptions: { label: string; value: number | null }[] = [
		{ label: 'All', value: null },
		{ label: '1', value: 1 },
		{ label: '2', value: 2 },
		{ label: '3', value: 3 },
		{ label: '4', value: 4 },
		{ label: '5', value: 5 }
	];

	followupRequestFilterOptions: { label: string; value: boolean | null }[] = [
		{ label: 'All', value: null },
		{ label: 'Yes', value: true },
		{ label: 'No', value: false }
	];

	filterReservationistRank: number | null = null;
	filterVehicleRank: number | null = null;
	filterPreArrivalRank: number | null = null;
	filterCheckinRank: number | null = null;
	filterMaintRank: number | null = null;
	filterSvcRank: number | null = null;
	filterOverallRank: number | null = null;
	filterFollowupRequest: boolean | null = null;
	filterReceiveDate: Date | null = null;
	filterGuestFollowupDate: Date | null = null;

	@ViewChild('pt') table: Table;

	columns: any[] = [
		{ field: 'guestExitSurveyId', header: 'Id', width: 'auto' },
		{ field: 'reservationId', header: 'Res #', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		{ field: 'surveyStage', header: 'Stage', width: 'auto' },
		{ field: 'receiveDate', header: 'Receive Date', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'overallExperienceRank', header: 'Overall', width: 'auto' },
		{ field: 'reservationistRank', header: 'Reservationist', width: 'auto' },
		{ field: 'vehicleReservationProcessRank', header: 'Vehicle Rez', width: 'auto' },
		{ field: 'preArrivalInfoRank', header: 'Pre-Arrival', width: 'auto' },
		{ field: 'checkinProcessRank', header: 'Check-in', width: 'auto' },
		{ field: 'propertyMaintenanceRank', header: 'Maint', width: 'auto' },
		{ field: 'guestServicesQualityRank', header: 'Service', width: 'auto' },
		{ field: 'overallExperienceFeedbackDesc', header: 'Feedback', width: 'auto' },
		{ field: 'guestName', header: 'Name', width: 'auto' },
		{ field: 'guestEmail', header: 'Email', width: 'auto' },
		{ field: 'guestPhone', header: 'Phone', width: 'auto' },
		{ field: 'guestFollowupRequest', header: 'Followup Request', width: 'auto' },
		{ field: 'guestFollowupDate', header: 'Followup Date', width: 'auto' },
	];
	openingReservation: any = {};

	ngOnInit(): void {
		try {
			const params = this.route.snapshot.queryParams;
			if (params['overallExperienceRank']) {
				this.initialOverallRankFilter = params['overallExperienceRank'];
				this.filterOverallRank = parseInt(params['overallExperienceRank'], 10);
			}
			if (params['receiveDate']) {
				this.initialReceiveDateFilter = params['receiveDate'];
				// Set calendar model to show date visually (use noon to avoid timezone shift)
				this.filterReceiveDate = new Date(params['receiveDate'] + 'T12:00:00');
			}
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestExitSurveyId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	openReservation(reservation: any, event: any) {
		let reservationId = reservation?.reservationId;
		event.stopPropagation();
		this.openingReservation[reservationId] = true;
		this.reservationService.getOrderIdByReservationId(reservationId).pipe(first()).subscribe(
		  (res: any) => {
			console.log('Order ID: ' + JSON.stringify(res));
			window.open(`https://admin.kbmhawaii.com/order/${res.data.orderId}`, '_blank');
			this.openingReservation[reservationId] = false;
		  },
		  (err: any) => {
			console.log('Error fetching order ID: ' + JSON.stringify(err));
			this.openingReservation[reservationId] = false;
		  }
		);
	  }


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// Inject URL query param filters — must run on every loadLazy call (including the first)
			// to prevent a race condition where the initial unfiltered API response overwrites the filtered one
			if (this.initialOverallRankFilter) {
				Object.assign(event.filters, { 'overallExperienceRank': { 'value': parseInt(this.initialOverallRankFilter, 10), 'matchMode': 'equals' } });
			}
			if (this.initialReceiveDateFilter) {
				Object.assign(event.filters, { 'receiveDate': { 'value': this.initialReceiveDateFilter, 'matchMode': 'equals' } });
			}

			if (!event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestExitSurveyService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestExitSurveys = res.data.guestExitSurveys;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestExitSurveys = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestExitSurvey: GuestExitSurvey) {
		try {
			this.formLoading = true;
			this.guestExitSurveyService.update(guestExitSurvey)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestExitSurveys.map((guestExitSurvey, i) => {
							if (guestExitSurvey.guestExitSurveyId === res.data.guestExitSurvey.guestExitSurveyId) {
								this.guestExitSurveys[i] = res.data.guestExitSurvey;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestExitSurvey: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestExitSurvey));

			this.formLoading = true;
			this.guestExitSurveyService.delete(guestExitSurvey.guestExitSurveyId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestExitSurveys.splice(this.guestExitSurveys.indexOf(guestExitSurvey), 1);
						this.recordTotal = this.guestExitSurveys.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestExitSurvey ' + guestExitSurvey.guestExitSurveyId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestExitSurvey ' + guestExitSurvey.guestExitSurveyId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Guest Exit Survey'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestExitSurveyComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestExitSurveyCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestExitSurvey: GuestExitSurvey) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestExitSurvey: guestExitSurvey,
			title: 'Edit Guest Exit Survey'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestExitSurveyComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestExitSurveyCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestExitSurveyCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestExitSurveyCB(guestExitSurvey: GuestExitSurvey) {
		console.log('Adding GuestExitSurvey: ' + JSON.stringify(guestExitSurvey));
		// if we don't have a guestExitSurveys array yet...
		if (!this.guestExitSurveys) {
			this.guestExitSurveys = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.guestExitSurveys.unshift(guestExitSurvey);

		// no idea what this is but it is required to update the array
		this.guestExitSurveys = [...this.guestExitSurveys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestExitSurvey ' + guestExitSurvey.guestExitSurveyId + ' Added', life: 3000 });
	}

	updateGuestExitSurveyCB(guestExitSurvey: GuestExitSurvey) {
		console.log('Updating GuestExitSurvey: ' + JSON.stringify(guestExitSurvey));
		let itemIndex = this.guestExitSurveys.findIndex((item: any) => item.guestExitSurveyId === guestExitSurvey.guestExitSurveyId);
		this.guestExitSurveys[itemIndex] = guestExitSurvey;

		// no idea what this is but it is required to update the array
		this.guestExitSurveys = [...this.guestExitSurveys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestExitSurvey ' + guestExitSurvey.guestExitSurveyId + ' Updated', life: 3000 });
	}

	deleteGuestExitSurveyCB(guestExitSurvey: GuestExitSurvey) {
		console.log('Removing GuestExitSurvey: ' + guestExitSurvey);
		this.guestExitSurveys.splice(this.guestExitSurveys.indexOf(guestExitSurvey), 1);
		this.recordTotal = this.guestExitSurveys.length;

		// no idea what this is but it is required to update the array
		this.guestExitSurveys = [...this.guestExitSurveys];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestExitSurvey ' + guestExitSurvey.guestExitSurveyId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestExitSurveys ? this.first === (this.guestExitSurveys.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestExitSurveys ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(guestExitSurvey: any) {
		if (guestExitSurvey?.status) {
			const status = this.statuses.find((e: any) => e.value == guestExitSurvey.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	getSurveyStageName(surveyStage: any): string {
		if (!surveyStage) return '';
		const stage = this.constantService.surveyStages.find(
			(e: any) => e.value == surveyStage.toString()
		);
		return stage ? stage.name : '';
	}

	onDateFilter(value: Date | null, field: string): void {
		const formatted = value ? moment(value).format('YYYY-MM-DD') : null;
		this.table?.filter(formatted, field, 'equals');
		this.triggerLazyWithCurrentFilters();
	}

	private triggerLazyWithCurrentFilters(): void {
		const event = this.table?.createLazyLoadMetadata();
		if (event) {
			this.loadLazy(event);
		}
	}

}
